<template>
  <div style="height: 100%">
    <div class="add-user-devices ubv">
      <div class="ub-f1 ubv" style="border: 1px solid #e6ebf2; border-radius: 3px; height: 0">
        <organ-device-auto :orgId="orgId" :userId="userId" @success="loadDevices"></organ-device-auto>
      </div>
      <div style="height: 16px"></div>
      <!-- 已关联的设备、项目 -->
      <div class="ub-f1 ubv" style="border: 1px solid #e6ebf2; border-radius: 3px; height: 0">
        <custom-tab v-model="currentTab" :list="tabs"></custom-tab>
        <!-- 已关联的设备 -->
        <div class="ub-f1 ubv" style="padding: 0 16px; height: 0" key="tab2" v-if="currentTab == 'tab1'">
          <organ-device-bind ref="tab1" class="ub-f1 ubv" style="height: 0" :permission="{ add: true, del: true }" :user="{ bizId: userId, bizType: 3 }" :organ="{ orgId: orgId || rootOrgId }"></organ-device-bind>
        </div>
        <!-- 已关联项目 -->
        <div class="ub-f1 ubv" style="padding: 0 16px; height: 0" key="tab2" v-if="currentTab == 'tab2'">
          <user-location ref="tab2" class="ub-f1 ubv" style="height: 0" vheight="100%" :userId="userId"></user-location>
        </div>
      </div>
      <div style="height: 16px"></div>
    </div>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('base_user_item_step_devices.shang_yi_bu') }}</el-button>
      <el-button type="primary" @click="onStep">{{ $t('Common.com_save') }}</el-button>
    </div>
  </div>
</template>

<script>
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import userLocation from '../../user/children/user_location';
import organDeviceAuto from '../../organdevice/children/organ_device_auto.vue';
import organDeviceBind from '../../organdevice/children/organ_device_bind.vue';

export default {
  mixins: [resetFormSearchMixins],
  components: {
    userLocation,
    organDeviceAuto,
    organDeviceBind,
  },
  props: {
    userId: [String, Number],
  },
  data() {
    return {
      orgId: '',
      currentTab: 'tab1',
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: this.$t('base_user_item_step_devices.ji_qi'),
          value: 'tab1',
          code: 'tab1',
        },
        {
          name: this.$t('base_user_item_step_devices.xiang_mu'),
          value: 'tab2',
          code: 'tab2',
        },
      ];
    },
    rootOrgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
  },
  mounted: function () {
    this.orgId = this.getJump('orgId');
  },
  methods: {
    onCancel: function () {
      this.$emit('cancel');
    },
    onBack: function () {
      this.$emit('back');
    },
    onStep: function () {
      this.$emit('step', { name: 'device' });
    },
    loadDevices() {
      this.$nextTick(() => {
        if (this.$refs.tab1) {
          this.$refs.tab1.onPageChange({ page: 1 });
        }
        if (this.$refs.tab2) {
          this.$refs.tab2.onPageChange({ page: 1 });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';

.add-user-devices {
  height: 100%;
  .side .el-input--mini .el-input__inner {
    line-height: 26px;
    height: 26px;
  }
  .device-wrap {
    border: 1px solid #e6ebf2;
    & > .ub {
      height: 100%;
    }
    .side {
      border-right: 1px solid #e4e4e4;
      padding: 10px;
      & > ul > li {
        cursor: pointer;
        height: 40px;
        padding-right: 2px;
        padding: 7px 12px;
        &.cur {
          background-color: #eef2f8;
          .name {
            @include color_main();
          }
        }
        &.auto .el-input__inner {
          color: #879cbb;
          border: 1px solid rgba(222, 226, 230, 1);
        }
        .name {
          color: #262626;
          font-size: 12px;
          padding-left: 10px;
          line-height: 26px;
        }
      }
    }
    .tree .tree-item {
      padding-right: 2px;
    }
    .is-current > .el-tree-node__content {
      background-color: $main-color;
      .tree-item {
        color: #ffffff;
        .icon {
          color: #ffffff !important;
          font-size: 12px;
        }
        .disable {
          color: #ffffff;
        }
      }
    }
  }
}
</style>
